import { Client } from '@/api/systemAnalyzerApi/client'
import { downloadDebugLog, downloadErrorLog } from '@/api/systemAnalyzerApi/sdk.gen'
import { DIAGNOSTICS_LOG_DOWNLOAD_SIZE_MB } from '@/constants'
import { Stack, Tabs } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import LogDownloadCard from './LogDownloadCard'

const LogDownloadsPanel = ({ client }: { client: Client }) => {
  const { t } = useTranslation(['diagnostics', 'common'])

  return (
    <Tabs.Panel value="log-downloads">
      <Stack gap="md" mt="lg">
        <LogDownloadCard
          label={t('debugLog')}
          fileName="debug.jsonl"
          sizeMb={DIAGNOSTICS_LOG_DOWNLOAD_SIZE_MB}
          fetchLog={async () => {
            const { data } = await downloadDebugLog({ client, parseAs: 'blob', throwOnError: true })
            return { blob: data as Blob, fileName: 'debug.jsonl' }
          }}
        />
        <LogDownloadCard
          label={t('errorLog')}
          fileName="error.jsonl"
          sizeMb={DIAGNOSTICS_LOG_DOWNLOAD_SIZE_MB}
          fetchLog={async () => {
            const { data } = await downloadErrorLog({ client, parseAs: 'blob', throwOnError: true })
            return { blob: data as Blob, fileName: 'error.jsonl' }
          }}
        />
      </Stack>
    </Tabs.Panel>
  )
}

export default LogDownloadsPanel
